import { z } from 'zod';
/** The two languages the app has (REQUIREMENTS §2.8). Hebrew is the default and the fallback. */
export const languageSchema = z.enum(['he', 'en']);
/**
 * Company-wide switches an admin flips on the settings page (story 33).
 * One document, `settings/app`, server-only; the public registration
 * endpoint reads it on every call.
 */
export const appSettingsSchema = z.object({
    /** The public self-registration form (story 33). Off means the form and its endpoint refuse. */
    selfRegistrationEnabled: z.boolean().default(true),
    /**
     * The language everyone sees (owner, 2026-09-19, story 38): there is no
     * per-user switch any more — the admin picks it here and the whole app,
     * sign-in screen included, follows. English stays translated for when it
     * is wanted.
     */
    language: languageSchema.default('he'),
});
export const settingsResponseSchema = z.object({ settings: appSettingsSchema });
/** PATCH /api/settings — admin; any subset. */
export const updateSettingsRequestSchema = appSettingsSchema.partial().refine((b) => Object.keys(b).length > 0, {
    message: 'At least one setting must be supplied',
});
/**
 * GET /api/public/config — what a browser needs before anyone is signed in.
 * Only the language: nothing else on the settings document is public.
 */
export const publicConfigResponseSchema = z.object({ language: languageSchema });
//# sourceMappingURL=settings.js.map